import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "./PrivacyPolicy.css"; 

const Faqs = () => {
  const navigate = useNavigate();

  return (
    <div className="privacy-policy-page">
      <button className="back-btn" onClick={() => navigate('/')}>
        <FaArrowLeft />
      </button>

      <h1>FAQ</h1>
      <h2>Digital Gold Rewards – FAQ for Discount Dost Users</h2>

      <h3>What is Digital Gold on Discount Dost?</h3>
      <p>
        Digital Gold is real 24K physical gold stored securely in your name.
        With every deal you redeem on Discount Dost, you earn digital gold rewards that grow over time — making each transaction not just a saving, but a wealth-building opportunity.
      </p>

      <h3>How is Digital Gold better than regular discounts or cashback?</h3>
      <p>
        Unlike typical discounts or points that lose value over time, gold appreciates in value.
        You’re not just saving — you’re accumulating an appreciating asset.
        Gold has been a trusted store of value in India for generations, and with Discount Dost, you build wealth without even realizing it — one purchase at a time.
      </p>

      <h3>Is it real gold or just digital numbers?</h3>
      <p>
        It’s real, physical gold (24K investment-grade) stored in a secure vault on your behalf by our trusted partner SafeGold — a SEBI-compliant platform.
        This is not paper gold, not crypto, and not virtual points.
        Your gold is fully insured and can be redeemed for physical delivery or cash anytime.
      </p>

      <h3>How much do I need to spend to start earning gold?</h3>
      <p>
        You can start earning gold with every qualifying purchase on Discount Dost.
        Even if your transaction is just ₹100, a percentage of your savings gets credited as digital gold — starting from as little as ₹10.
      </p>

      <h3>How is my gold stored and protected?</h3>
      <ul>
        <li>Stored in 100% insured, world-class vaults (operated by Brinks)</li>
        <li>Backed by SafeGold, a SEBI-registered trustee</li>
        <li>Audited and transparently managed for your safety</li>
        <li>You can track your gold balance 24/7 through the Discount Dost wallet.</li>
      </ul>

      <h3>Can I convert my digital gold to physical gold?</h3>
      <p>Yes. Once you've accumulated enough gold (starting from 0.5g), you can:</p>
      <ul>
        <li>Request physical delivery to your home in tamper-proof packaging</li>
        <li>Exchange it for jewellery via partner jewellers like CaratLane & Candere</li>
        <li>Sell it back for cash at real-time market-linked prices</li>
      </ul>

      <h3>Can I track my gold rewards?</h3>
      <p>Absolutely. Your Discount Dost dashboard allows you to:</p>
      <ul>
        <li>View your gold balance in grams and ₹</li>
        <li>See how much gold you earned from each deal</li>
        <li>Request redeem, delivery, or sell-back options instantly</li>
      </ul>

      <h3>How does gold add value over time?</h3>
      <p>
        Gold is known for its stability and long-term appreciation.
        When the market fluctuates, gold often holds or increases its value, making it a safe investment.
        So instead of just spending and saving, you’re growing wealth — just by using Discount Dost.
        <br />
        <em>“It’s like earning compound interest every time you grab a coffee or get a haircut.”</em>
      </p>

      <h3>Can I gift my digital gold to someone else?</h3>
      <p>
        Yes! Gifting digital gold is a meaningful and timeless gesture.
        Discount Dost allows you to gift gold to loved ones — anytime, anywhere — digitally, with just a few taps.
      </p>

      <h3>Is there any fee for earning or holding digital gold?</h3>
      <p>
        No hidden charges. No subscription. No storage fees.
        Gold rewards are completely free to you, as part of your benefit for shopping via Discount Dost.
      </p>

      <h2>Start Building Wealth, One Deal at a Time</h2>
      <p>
        With 11,202+ transactions every hour and growing, customers across India are saving smart and accumulating real gold every single day.
        <br />
        <strong>Buy 24K Gold in 24 Seconds.</strong><br />
        Start your wealth journey with just ₹10.
      </p>
    </div>
  );
};

export default Faqs;
